import { render, staticRenderFns } from "./Discussion.vue?vue&type=template&id=b4cd2da0&scoped=true&"
import script from "./Discussion.vue?vue&type=script&lang=js&"
export * from "./Discussion.vue?vue&type=script&lang=js&"
import style0 from "./Discussion.vue?vue&type=style&index=0&id=b4cd2da0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4cd2da0",
  null
  
)

export default component.exports